module.exports = __webpack_public_path__ + "themes/fq/sprite/green-button@2x.json";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/sprite/green-button@2x.json
// module id = 99
// module chunks = d-game